(function () {
  'use strict';

  var ARABIC_RE = /[\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF\uFB50-\uFDFF\uFE70-\uFEFF]/;

  function containsArabic(text) {
    return ARABIC_RE.test(text);
  }

  function getOriginalQueryFromUrl() {
    try {
      return new URLSearchParams(window.location.search).get('original_q') || '';
    } catch (e) {
      return '';
    }
  }

  function restoreOriginalQuery() {
    var originalQuery = getOriginalQueryFromUrl();
    if (!originalQuery || !containsArabic(originalQuery)) return;

    document.querySelectorAll('input[type="search"], input[name="q"]').forEach(function (input) {
      input.value = originalQuery;
    });
  }

  function addOriginalQueryToSearchLinks(originalQuery) {
    if (!originalQuery || !containsArabic(originalQuery)) return;

    document.querySelectorAll('#predictive-search a[href*="/search"]').forEach(function (link) {
      try {
        var url = new URL(link.href, window.location.origin);
        if (url.searchParams.has('q') && !url.searchParams.has('original_q')) {
          url.searchParams.set('original_q', originalQuery);
          link.href = url.toString();
        }
      } catch (e) {
        // Ignore invalid URLs.
      }
    });
  }

  // --- Translation via Weglot JS SDK ---
  // Weglot.translate() is callback-based; wrap it in a Promise with a timeout.
  function translateViaWeglotSDK(text) {
    return new Promise(function (resolve) {
      var settled = false;
      var timeout = setTimeout(function () {
        if (!settled) { settled = true; resolve(null); }
      }, 2000);

      window.Weglot.translate(
        { words: [{ w: text, t: 1 }], languageTo: 'en', languageFrom: 'ar' },
        function (translations) {
          clearTimeout(timeout);
          if (!settled) {
            settled = true;
            resolve(
              translations && translations[0] && translations[0] !== text
                ? translations[0]
                : null
            );
          }
        }
      );
    });
  }

  // --- Translation via Weglot REST API (key is already public on the page) ---
  async function translateViaWeglotREST(text, apiKey) {
    var res = await fetch(
      'https://api.weglot.com/translate?api_key=' + encodeURIComponent(apiKey),
      {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          l_from: 'ar',
          l_to: 'en',
          request_url: window.location.href,
          words: [{ w: text, t: 1 }],
        }),
      }
    );
    if (!res.ok) return null;
    var data = await res.json();
    var translated = data && data.to_words && data.to_words[0];
    return translated && translated !== text ? translated : null;
  }

  // --- Fallback: MyMemory free translation API ---
  async function translateViaMyMemory(text) {
    var res = await fetch(
      'https://api.mymemory.translated.net/get?q=' +
        encodeURIComponent(text) +
        '&langpair=ar|en'
    );
    if (!res.ok) return null;
    var data = await res.json();
    var translated =
      data && data.responseData && data.responseData.translatedText;
    return translated && translated !== text ? translated : null;
  }

  // Try Weglot (SDK → REST), then MyMemory. Returns original text if all fail.
  async function translateToEnglish(text) {
    try {
      // 1. Weglot JS SDK
      if (
        window.Weglot &&
        typeof window.Weglot.translate === 'function' &&
        window.Weglot.initialized
      ) {
        var result = await translateViaWeglotSDK(text);
        if (result) return result;
      }

      // 2. Weglot REST API (key is already visible in the page source)
      var apiKey =
        window.Weglot &&
        window.Weglot.options &&
        (window.Weglot.options.api_key || window.Weglot.options.key);
      if (apiKey) {
        var result2 = await translateViaWeglotREST(text, apiKey);
        if (result2) return result2;
      }

      // 3. MyMemory fallback
      var result3 = await translateViaMyMemory(text);
      if (result3) return result3;
    } catch (e) {
      // silent — return original below
    }

    return text;
  }

  // Patch BlsSearchShopify.getSearchResults so live/predictive search
  // can use English product data without changing the Arabic text the user typed.
  function patchPredictiveSearch() {
    if (
      typeof BlsSearchShopify === 'undefined' ||
      typeof BlsSearchShopify.getSearchResults !== 'function'
    )
      return;

    var _original = BlsSearchShopify.getSearchResults;
    var _renderOriginal = BlsSearchShopify.renderSearchResults;
    var lastOriginalArabicQuery = '';

    if (typeof _renderOriginal === 'function') {
      BlsSearchShopify.renderSearchResults = function (resultsMarkup) {
        _renderOriginal.call(BlsSearchShopify, resultsMarkup);
        addOriginalQueryToSearchLinks(lastOriginalArabicQuery);
      };
    }

    BlsSearchShopify.getSearchResults = async function (searchTerm) {
      lastOriginalArabicQuery = '';
      if (containsArabic(searchTerm)) {
        lastOriginalArabicQuery = searchTerm;
        var translated = await translateToEnglish(searchTerm);
        if (translated !== searchTerm) {
          searchTerm = translated;
        }
      }
      return _original.call(BlsSearchShopify, searchTerm);
    };
  }

  // Intercept every search form submission.
  // Capture phase ensures we fire before other submit listeners.
  function setupFormTranslation() {
    document.addEventListener(
      'submit',
      async function (e) {
        var form = e.target;
        if (
          !form ||
          (!form.matches('form[role="search"]') &&
            !(form.action && form.action.includes('/search')))
        )
          return;

        var input =
          form.querySelector('input[type="search"]') ||
          form.querySelector('input[name="q"]');
        if (!input) return;

        var query = input.value.trim();
        if (!query || !containsArabic(query)) return;

        e.preventDefault();
        e.stopImmediatePropagation();

        var translated = await translateToEnglish(query);
        if (translated === query) {
          form.submit();
          return;
        }

        var formData = new FormData(form);
        var url = new URL(form.action || window.location.href, window.location.origin);
        formData.forEach(function (value, key) {
          url.searchParams.set(key, value);
        });
        url.searchParams.set('q', translated);
        url.searchParams.set('original_q', query);
        window.location.href = url.toString();
      },
      true // capture phase
    );
  }

  function init() {
    restoreOriginalQuery();
    setupFormTranslation();
    patchPredictiveSearch();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
